var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      staticStyle: { "z-index": "2014" },
      attrs: {
        visible: _vm.trackingVisible,
        title: _vm.$t("OrdinaryOrderMix.LogisticsTable.TrackingDetails"),
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "before-close": _vm.handleClose,
        "append-to-body": true,
        width: "700px",
      },
      on: {
        "update:visible": function ($event) {
          _vm.trackingVisible = $event
        },
      },
    },
    [
      _c(
        "div",
        {
          staticStyle: {
            width: "100%",
            height: "30px",
            display: "flex",
            "justify-content": "space-between",
            "align-items": "center",
            "padding-bottom": "20px",
          },
        },
        [
          _c("div", { staticStyle: { width: "45%" } }, [
            _vm._v(
              _vm._s(_vm.$t("OrdinaryOrderMix.LogisticsTable.TrackingNo")) +
                " : " +
                _vm._s(_vm.trackingId)
            ),
          ]),
          _c(
            "div",
            {
              staticStyle: {
                width: "45%",
                display: "flex",
                "align-items": "center",
              },
            },
            [
              _c("div", { staticStyle: { width: "115px" } }, [
                _vm._v(
                  _vm._s(_vm.$t("OrdinaryOrderMix.LogisticsTable.ParcelNo"))
                ),
              ]),
              _c("BjSelectLov", {
                attrs: {
                  disabled: _vm.disParcel,
                  placeholder: _vm.$t("chooseText"),
                  "option-list": _vm.ParcelNoList,
                },
                on: { change: _vm.getTableData },
                model: {
                  value: _vm.ParcelNo,
                  callback: function ($$v) {
                    _vm.ParcelNo = $$v
                  },
                  expression: "ParcelNo",
                },
              }),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-table",
        {
          attrs: {
            data: _vm.trackingTableData,
            stripe: "",
            border: "",
            "header-cell-style": _vm.$rowStyle.DEFAULT,
            "max-height": "500px",
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("OrdinaryOrderMix.LogisticsTable.TrackingStatus"),
              align: "center",
              prop: "lastStatus",
              width: "222",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("OrdinaryOrderMix.LogisticsTable.TrackingLocation"),
              align: "center",
              prop: "lastLocation",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("OrdinaryOrderMix.LogisticsTable.TrackingTime"),
              align: "center",
              prop: "lastLogisDate",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm._f("timeFilters")(
                            scope.row.lastLogisDate,
                            scope.row.lastLogisDate
                          )
                        ) +
                        " "
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }